import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../../../styles.scss'

const NewsItem = props => (
    <div>
        <h4 className={styles.date}>
            {props.published.substring(0, props.published.indexOf('T'))}
        </h4>
        <p onClick={() => props.onClick(props.link)} aria-hidden>
            {props.title}
        </p>
    </div>
)

NewsItem.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
    published: PropTypes.string,
    onClick: PropTypes.func,
}

export default NewsItem



// WEBPACK FOOTER //
// ./src/features/News/components/Feed/components/NewsItem/index.js